import { useMemo } from 'react'

import { Roles } from 'constants/EntityConstants'
import { useGetDriverIdentityRoleQuery } from 'generated/graphql'

export const useDriverRole = (driverId: number | undefined): keyof typeof Roles => {
  const { data: driverIdentityData } = useGetDriverIdentityRoleQuery({
    variables: {
      driverId,
    },
    skip: !driverId,
  })

  const currentRole = useMemo(() => {
    if (driverIdentityData?.driver?.role && driverIdentityData.driver.role.length > 0) {
      return driverIdentityData.driver.role[0] as keyof typeof Roles
    }
    return '' as keyof typeof Roles
  }, [driverIdentityData])

  return currentRole
}
